import { Bean } from '@dreryk/react-common';

import { FormsTemplatesPortal } from '../FormsTemplates.portal';
import { FormsTemplatesContext, useFormsTemplatesContext } from '../formsTemplatesContext';

type FormsTemplateFormSectionChildrenRenderProps<ITEM extends Bean> = Pick<
   FormsTemplatesContext<ITEM>,
   'activeItem' | 'enableSwitching' | 'disableSwitching' | 'setActiveItemName' | 'templatesApiRef'
>;

type VisitFormsTemplateFormSectionProps<ITEM extends Bean> = {
   readonly children: (renderProps: FormsTemplateFormSectionChildrenRenderProps<ITEM>) => JSX.Element;
};

export type { FormsTemplateFormSectionChildrenRenderProps as FormsTemplateFormSectionProps };

export const FormsTemplateFormSection = <ITEM extends Bean>(
   props: VisitFormsTemplateFormSectionProps<ITEM>
): JSX.Element | null => {
   const {
      mode,
      activeItem,
      enableSwitching,
      disableSwitching,
      setActiveItemName,
      templatesApiRef,
   } = useFormsTemplatesContext<ITEM>();

   if (mode !== 'EDIT') {
      return null;
   }

   return (
      <FormsTemplatesPortal>
         {props.children({
            activeItem: activeItem,
            setActiveItemName: setActiveItemName,
            enableSwitching: enableSwitching,
            disableSwitching: disableSwitching,
            templatesApiRef: templatesApiRef,
         })}
      </FormsTemplatesPortal>
   );
};
